import * as AdbModule from "@yume-chan/adb";

/** Run a shell command on the connected device via ADB subprocess service */
export async function shellCmd(adb: any, command: string[]): Promise<string> {
  const Svc = (AdbModule as any).AdbSubprocessService;
  const svc = new Svc(adb);
  const shell = svc.shellProtocol;
  if (shell) {
    const result = await shell.spawnWaitText(command);
    return result.stdout + result.stderr;
  }
  return svc.noneProtocol.spawnWaitText(command);
}
